import { render } from "./ValidationBankAccountFormContainer.vue?vue&type=template&id=3b48d326"
import script from "./ValidationBankAccountFormContainer.vue?vue&type=script&lang=js"
export * from "./ValidationBankAccountFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__